import { render, staticRenderFns } from "./view-risk.vue?vue&type=template&id=24c70fc4&scoped=true"
import script from "./view-risk.vue?vue&type=script&lang=js"
export * from "./view-risk.vue?vue&type=script&lang=js"
import style0 from "./view-risk.vue?vue&type=style&index=0&id=24c70fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c70fc4",
  null
  
)

export default component.exports